<template>
  <div>
    <div class="app-block p-md m-md">
      <form @submit.prevent="send">
        <h3 class="heading-line title is-4 has-text-weight-light"><span
            :class="'school-title-'+schoolSlug">3 - Projet</span></h3>
        <div class="content">
          <div>
            <i>Décrivez en quelques mots votre projet et ce qui vous pousse à suivre cette formation.</i>
          </div>
          <div>
            <quill-editor class="app-editor"
                          ref="motivationEditor"
                          v-model="motivations.motivation"
                          :options="editorOption"
                          @change="onEditorChange($event)">
            </quill-editor>


          </div>
          <div class='has-text-right has-text-weight-bold is-italic'
               v-bind:class="{'has-text-danger has-text-weight-bold': hasError }">
                        <span v-if="remainingCount>0">
                            Il vous reste au moins {{ remainingCount }} caractères à écrire
                        </span>
          </div>

          <div class="has-text-right m-t-md">
            <transition name="slide-fade">
              <div class="has-text-danger has-text-centered">{{ errorMsg }}</div>
            </transition>
            <div v-if="hasError" class="has-text-warning has-text-weight-bold">
              <div class="has-text-centered">{{ textError }}</div>
            </div>
            <button :class="'button-valid button ' + isLoading" v-if="user.isLoggedIn">
              Sauvegarder
            </button>
            <button class="button" v-else disabled>
              Sauvegarder
            </button>
          </div>
        </div>
      </form>

    </div>
  </div>

</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'

export default {
  data() {
    return {
      isLoading: '',
      errorMsg: '',
      contentText: '',
      motivations: {
        motivation: ''
      },
      minCount: 1500,
      maxCount: 8000,
      remainingCount: 1500,
      hasError: false,
      textError: null,
      editorOption: {
        theme: 'snow',
        placeholder: '....',
        modules: {
          clipboard: {
            allowed: {
              tags: ['a', 'b', 'strong', 'u', 's', 'i', 'p', 'br', 'ul', 'ol', 'li', 'span'],
              attributes: ['href', 'rel', 'target', 'class']
            },
            keepSelection: true,
            substituteBlockElements: true,
            magicPasteLinks: true,
            hooks: {
              uponSanitizeElement(node, data, config) {
                console.log(node);
              },
            },
          },
          toolbar: [
            ['bold', 'italic', 'underline'],
            [{'list': 'ordered'}, {'list': 'bullet'}],
            [{'header': [1, 2, 3, 4, 5, 6, false]}],
            [{'font': []}],
            [{'align': []}],
            ['link'],
            ['clean']
          ]
        }
      }
    }
  },
  props: {
    school: {type: Object},
    schoolSlug: {type: String},
    candidate: {type: Object},
    application: {type: Object},
  },
  computed: {
    ...mapGetters({
      status: 'candidate/getStatus'
    }),
    ...mapState({
      user: 'auth'
    })

  },
  methods: {
    ...mapActions({
      sendMotivation: 'candidate/saveMotivation'
    }),
    toggleLoading: function () {
      this.isLoading = (this.isLoading === '') ? 'is-loading' : ''
    },
    onEditorChange({editor, html, text}) {

      let t = text.replace(/(\r\n|\n|\r|\s+)/g, '')
      this.remainingCount = this.minCount - (t.length - 1);
      this.hasError = t.length > 8000;
      if (t.length > 8000) {
        this.textError = 'Veuillez raccourcir votre texte'
      }

      this.contentText = t
      this.motivations.motivation = html

    },
    send: function () {
      this.toggleLoading()
      this.motivations.candidate_id = this.candidate.id
      this.motivations.school_id = this.application.school_id
      this.sendMotivation(this.motivations).then((result) => {
        if (this.status === 200) {
          this.toggleLoading()
          if (this.remainingCount <= 0) {
            this.$emit('send')
          }
        } else if (this.status === 403) {
          this.toggleLoading()
          this.$emit('notAuthenticated')
        } else {
          this.toggleLoading()
          this.errorMsg = 'Une erreur s\'est produite veuillez réessayer plus tard'
        }
      }).catch((err) => {
        this.toggleLoading()
        this.errorMsg = 'Une erreur s\'est produite veuillez réessayer plus tard'
      })

      if (this.remainingCount > 0) {
        this.$buefy.toast.open({
          message: "Pour que vos motivations soient complètes, il vous reste à ajouter au moins "+ this.remainingCount +" caractères",
          type: 'is-warning',
          duration: 3000,
        })
      }
    }
  },
  created: function () {
    this.motivations.motivation = this.application.motivation

    if (this.motivations.motivation) {
      let text = this.motivations.motivation.replace(/(\r\n|\n|\r|\s+)/g, '')
      if (text) {
        this.remainingCount = this.minCount - (text.length - 1);
        this.hasError = text.length > this.maxCount || text.length < this.minCount
        if (text.length > this.maxCount) {
          this.textError = 'Veuillez raccourcir votre texte'
        }
        if (text.length < this.minCount) {
          this.textError = 'Vos motivations doivent faire au moins 1500 caractères'
        }
      }
    }
  },
}
</script>
